import React from 'react';
import PropTypes from 'prop-types';
import UpcomingView from './UpcomingView';
import { starfishMediaType, SFNotification } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';

export default class UpcomingContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      upcomingEvents: null,
      hasFetched: false
    };
  }

  componentDidMount() {
    this.getAppointments();
  }

  getAppointments() {
    const URL = `../api/starfish/appointments/appointments/`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('appointments')
      }
    })
    .then(upcomingEvents => this.setState({upcomingEvents}))
    .catch(e => this.props.notification.error(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <UpcomingView
        {...this.state}
        notification={this.props.notification}
        timeZone={this.props.timeZone}
        getAppointments={this.getAppointments.bind(this)}
      />
    );
  }
}

UpcomingContainer.propTypes = {
  notification: SFNotification.isRequired,
  timeZone: PropTypes.string
};
